import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/saif-dc/Dcastalia/Node JS Projects/ygen-production/components/common/ygen/sections/blog-details/BlogDetails.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/saif-dc/Dcastalia/Node JS Projects/ygen-production/components/error/404.jsx");
